import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import filterCompute from '../computed/filterCompute'
import hasFilteredOptions from '../actions/hasFilteredOptions'
import hasFocusedOption from '../actions/hasFocusedOption'

export default [
  hasFilteredOptions,
  {
    true: [
      hasFocusedOption,
      {
        true: [
          ({ state, resolve, props }) => {
            const focusedOption = props.focusedOption

            if (focusedOption - 1 >= 0) {
              state.set(
                `selectr.${props.namespace}.focusedOption`,
                focusedOption - 1
              )
            } else {
              state.set(
                `selectr.${props.namespace}.focusedOption`,
                props.filteredOptions.length - 1
              )
            }
          }
        ],
        false: [set(state`selectr.${props`namespace`}.focusedOption`, 0)]
      }
    ],
    false: []
  }
]
